import React from 'react'
import block from 'bem-cn'

import { ReactComponent as Logo } from 'shared/img/logo.svg'

import { Icon } from 'components/UIKit'

import './ModalWrapper.scss'

type ModalWrapperProps = {
  className?: string
  title?: string
  onClose: () => void
  hideLogo?: boolean
}

const b = block('modal-wrapper')

export const ModalWrapper: React.FC<ModalWrapperProps> = ({ onClose, children, className, title, hideLogo }) => (
  <div className={b.mix(className)}>
    <div className={b('header')}>
      {hideLogo && title ? <div className={b('title')}>{title}</div> : !hideLogo && <Logo className={b('logo')} />}

      <Icon type="close" className={b('close')} onClick={onClose} />
    </div>

    <div className={b('content')}>
      {title && !hideLogo && <div className={b('title')}>{title}</div>}
      {children}
    </div>
  </div>
)
